<div class="panel-complementario__seccion">
	<ul class="nav panel-complementario__subtabs mb-4">
		<li class="nav-item">
			<span class="nav-link active">General</span>
		</li>
	</ul>
	<form [formGroup]="transporteGroupForm">
		<div class="row align-items-center mb-4" *ngIf="invoiceType === InvoiceType.Factura">
			<div class="col-md-6">
				<div class="custom-control custom-switch">
					<input type="checkbox" class="custom-control-input" id="facturaAcompanaTraslado" formControlName="facturaAcompanaTraslado" />
					<label class="custom-control-label label-control" for="facturaAcompanaTraslado">Esta factura acompaña traslado de bienes</label>
				</div>
			</div>
			<div class="col-md-6" *ngIf="transporteGroupForm.get('facturaAcompanaTraslado').value">
				<div class="row align-items-center">
					<label class="col-md-4 label-control mb-0" for="tipoDespacho">Tipo Despacho</label>
					<div class="col-md-8">
						<ng-select id="tipoDespacho" [items]="tipoDespachoSource" bindLabel="nombre" formControlName="tipoDespacho" [clearable]="false" (change)="onSubmit()"></ng-select>
					</div>
				</div>
			</div>
		</div>
		<ng-container *ngIf="invoiceType === InvoiceType.GuiaDespacho || transporteGroupForm.get('facturaAcompanaTraslado').value">
			<div class="row">
				<div class="col-md-3 form-group">
					<label class="label-control">Rut Transporte</label>
					<input type="text" maxlength="12" class="form-control" name="rutTransporte" appVerificaRut appFormatRut formControlName="rutTransporte" (change)="onSubmit()" />
					<div *ngIf="transporteGroupForm.controls.rutTransporte && (submitted || transporteGroupForm.controls.rutTransporte.touched) && transporteGroupForm.controls.rutTransporte.invalid" class="text-danger">
						<div *ngIf="transporteGroupForm.get('rutTransporte').hasError('rutNoValido')">Rut inválido</div>
						<div *ngIf="transporteGroupForm.controls.rutTransporte.errors?.maxlength">Máximo 10 caracteres</div>
					</div>
					<small class="form-text text-muted">Cuando corresponda.</small>
				</div>
				<div class="col-md-3 form-group">
					<label class="label-control">Patente</label>
					<input type="text" class="form-control" maxlength="8" formControlName="patente" (change)="onSubmit()" />
					<div *ngIf="transporteGroupForm.controls.patente && (submitted || transporteGroupForm.controls.patente.touched) && transporteGroupForm.controls.patente.invalid" class="text-danger">
						<div *ngIf="transporteGroupForm.controls.patente.errors?.maxlength">Máximo 8 caracteres</div>
					</div>
					<small class="form-text text-muted">Cuando corresponda.</small>
				</div>
				<div class="col-md-3 form-group">
					<label class="label-control">Rut Chofer</label>
					<input type="text" class="form-control" maxlength="12" formControlName="rutChofer" #rutChofer appVerificaRut appFormatRut (change)="onSubmit()" />
					<div *ngIf="transporteGroupForm.controls.rutChofer && (submitted || transporteGroupForm.controls.rutChofer.touched) && transporteGroupForm.controls.rutChofer.invalid" class="text-danger">
						<div *ngIf="transporteGroupForm.get('rutChofer').hasError('rutNoValido')">Rut inválido</div>
						<div *ngIf="transporteGroupForm.controls.rutChofer.errors?.maxlength">Máximo 10 caracteres</div>
					</div>
					<small class="form-text text-muted">Cuando corresponda.</small>
				</div>
				<div class="col-md-3 form-group">
					<label class="label-control">Nombre Chofer</label>
					<input type="text" class="form-control" maxlength="30" formControlName="nombreChofer" (change)="onSubmit()" />
					<div *ngIf="transporteGroupForm.controls.nombreChofer && (submitted || transporteGroupForm.controls.nombreChofer.touched) && transporteGroupForm.controls.nombreChofer.invalid" class="text-danger">
						<div *ngIf="transporteGroupForm.controls.nombreChofer.errors?.maxlength">Máximo 30 caracteres</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-3 form-group">
					<label class="label-control">Patente carro/remolque</label>
					<input type="text" class="form-control" maxlength="8" formControlName="patenteCarro" (change)="onSubmit()" />
					<div *ngIf="transporteGroupForm.controls.patenteCarro.touched && transporteGroupForm.controls.patenteCarro.errors?.maxlength" class="text-danger">Máximo 8 caracteres</div>
					<small class="form-text text-muted">Cuando corresponda.</small>
				</div>
				<div class="col-md-3 form-group" *ngIf="invoiceType === InvoiceType.GuiaDespacho">
					<label class="label-control">Dirección efectiva de destino</label>
					<input type="text" class="form-control" maxlength="70" formControlName="dirDest" (change)="onSubmit()" />
					<div *ngIf="transporteGroupForm.controls.dirDest.touched && transporteGroupForm.controls.dirDest.invalid" class="text-danger">
						<div *ngIf="transporteGroupForm.controls.dirDest.errors?.maxlength">Máximo 70 caracteres</div>
					</div>
				</div>
				<div class="col-md-3 form-group" *ngIf="invoiceType === InvoiceType.GuiaDespacho">
					<label class="label-control">Comuna efectiva de destino</label>
					<ng-select formControlName="cmnaDest" [items]="comunas" bindValue="nombre" bindLabel="nombre" [searchable]="true" placeholder="Comuna" (change)="onSubmit()"></ng-select>
					<div *ngIf="transporteGroupForm.controls.cmnaDest.touched && transporteGroupForm.controls.cmnaDest.invalid" class="text-danger">
						<div *ngIf="transporteGroupForm.controls.cmnaDest.errors?.maxlength">Máximo 20 caracteres</div>
					</div>
				</div>
				<div class="col-md-3 form-group">
					<label class="label-control">Fecha efectiva de salida</label>
					<input type="date" class="form-control" min="2003-04-01" max="2050-12-31" formControlName="fechaSalida" (change)="onSubmit()" />
				</div>
				<div class="col-md-3 form-group" *ngIf="invoiceType === InvoiceType.Factura">
					<label class="label-control">Hora efectiva de salida</label>
					<input type="time" step="1" class="form-control" formControlName="horaSalida" (change)="onSubmit()" />
				</div>
				<div class="col-md-3 form-group" *ngIf="invoiceType === InvoiceType.Factura">
					<label class="label-control">Fecha de llegada</label>
					<input type="date" class="form-control" min="2003-04-01" max="2050-12-31" formControlName="fechaLlegada" (change)="onSubmit()" />
					<div *ngIf="transporteGroupForm.hasError('fechaTrasladoFueraRango')" class="text-danger">Las fechas deben estar entre 01-04-2003 y 31-12-2050.</div>
					<div *ngIf="transporteGroupForm.hasError('fechaLlegadaAnterior')" class="text-danger">La fecha de llegada no puede ser anterior a la salida.</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6 form-group" *ngIf="invoiceType === InvoiceType.Factura">
					<div class="custom-control custom-switch mt-4">
						<input type="checkbox" class="custom-control-input" id="destinoDistintoReceptor" formControlName="destinoDistintoReceptor" />
						<label class="custom-control-label label-control" for="destinoDistintoReceptor">Destino distinto de la dirección del receptor</label>
					</div>
					<small class="form-text text-muted">Si no se marca, se utiliza la dirección y comuna del receptor.</small>
				</div>
				<div class="col-md-3 form-group" *ngIf="invoiceType === InvoiceType.GuiaDespacho">
					<label class="label-control">Hora efectiva de salida</label>
					<input type="time" step="1" class="form-control" formControlName="horaSalida" (change)="onSubmit()" />
				</div>
				<div class="col-md-3 form-group" *ngIf="invoiceType === InvoiceType.GuiaDespacho">
					<label class="label-control">Fecha de llegada</label>
					<input type="date" class="form-control" min="2003-04-01" max="2050-12-31" formControlName="fechaLlegada" (change)="onSubmit()" />
					<div *ngIf="transporteGroupForm.hasError('fechaTrasladoFueraRango')" class="text-danger">Las fechas deben estar entre 01-04-2003 y 31-12-2050.</div>
					<div *ngIf="transporteGroupForm.hasError('fechaLlegadaAnterior')" class="text-danger">La fecha de llegada no puede ser anterior a la salida.</div>
				</div>
				<div class="col-md-3 form-group" *ngIf="invoiceType === InvoiceType.Factura && transporteGroupForm.get('destinoDistintoReceptor').value">
					<label class="label-control">Dirección efectiva de destino</label>
					<input type="text" class="form-control" maxlength="70" formControlName="dirDest" (change)="onSubmit()" />
					<div *ngIf="transporteGroupForm.controls.dirDest.touched && transporteGroupForm.controls.dirDest.invalid" class="text-danger">
						<div *ngIf="transporteGroupForm.controls.dirDest.errors?.maxlength">Máximo 70 caracteres</div>
					</div>
				</div>
				<div class="col-md-3 form-group" *ngIf="invoiceType === InvoiceType.Factura && transporteGroupForm.get('destinoDistintoReceptor').value">
					<label class="label-control">Comuna efectiva de destino</label>
					<ng-select formControlName="cmnaDest" [items]="comunas" bindValue="nombre" bindLabel="nombre" [searchable]="true" placeholder="Comuna" (change)="onSubmit()"></ng-select>
					<div *ngIf="transporteGroupForm.controls.cmnaDest.touched && transporteGroupForm.controls.cmnaDest.invalid" class="text-danger">
						<div *ngIf="transporteGroupForm.controls.cmnaDest.errors?.maxlength">Máximo 20 caracteres</div>
					</div>
				</div>
			</div>

				<div class="form-group">
					<div class="d-flex align-items-center">
						<!-- Checkbox para Agregar Manejo Madera -->
						<div class="custom-control custom-switch mr-3">
							<input type="checkbox" class="custom-control-input" id="manejoMaderaCheckbox" formControlName="manejoMaderaCheckbox" />
							<label class="custom-control-label label-control" for="manejoMaderaCheckbox"> Agregar Manejo Madera </label>
						</div>

						<!-- Radio Buttons para tipo de búsqueda -->
						<div class="custom-control custom-radio mr-3" *ngIf="transporteGroupForm.get('manejoMaderaCheckbox').value">
							<input type="radio" id="buscarPorDireccionRadio" name="tipoBusqueda" class="custom-control-input" formControlName="tipoBusqueda" value="direccion" />
							<label class="custom-control-label label-control" for="buscarPorDireccionRadio"> Buscar por Dirección </label>
						</div>

						<div class="custom-control custom-radio" *ngIf="transporteGroupForm.get('manejoMaderaCheckbox').value">
							<input type="radio" id="buscarPorRolAvaluoRadio" name="tipoBusqueda" class="custom-control-input" formControlName="tipoBusqueda" value="rolAvaluo" />
							<label class="custom-control-label label-control" for="buscarPorRolAvaluoRadio"> Buscar por Rol Avalúo </label>
						</div>
					</div>
				</div>

				<div *ngIf="transporteGroupForm.get('tipoBusqueda').value === 'direccion' && transporteGroupForm.get('manejoMaderaCheckbox').value">
					<div class="row">
						<!-- Comuna, Dirección y Número en una misma línea -->
						<div class="col-12 form-group">
							<div class="row">
								<div class="col-md-3 label-control">Comuna</div>
								<div class="col-md-5 label-control">Dirección</div>
								<div class="col-md-2 label-control">Número</div>
							</div>
							<div class="row">
								<!-- Comuna -->
								<div class="col-md-3">
									<ng-select formControlName="comuna" [items]="comunas" placeholder="Comuna" bindValue="codigoSii" [searchable]="true" bindLabel="nombre"> </ng-select>
									<div *ngIf="transporteGroupForm.controls.comuna?.invalid && (transporteGroupForm.controls.comuna?.touched || submitted)" class="text-danger">
										<div *ngIf="transporteGroupForm.controls.comuna.errors?.required">Campo Requerido</div>
									</div>
									<div *ngIf="transporteGroupForm.controls.comunaRolOrigen?.invalid && (transporteGroupForm.controls.comunaRolOrigen?.touched || submitted)" class="text-danger">
										<div *ngIf="transporteGroupForm.controls.comunaRolOrigen.errors?.required">Campo Requerido</div>
									</div>
								</div>
								<!-- Dirección -->
								<div class="col-md-5">
									<input type="text" class="form-control" formControlName="direccionMadera" required placeholder="Dirección" />
									<div *ngIf="transporteGroupForm.controls.direccionMadera?.invalid && (transporteGroupForm.controls.direccionMadera?.touched || submitted)" class="text-danger">
										<div *ngIf="transporteGroupForm.controls.direccionMadera.errors?.required">Campo Requerido</div>
										<div *ngIf="transporteGroupForm.controls.direccionMadera.errors?.maxlength">Máximo 100 caracteres</div>
									</div>
								</div>
								<!-- Número -->
								<div class="col-md-2">
									<input type="number" class="form-control" formControlName="numeroMadera" required placeholder="Número" />
									<div *ngIf="transporteGroupForm.controls.numeroMadera?.invalid && (transporteGroupForm.controls.numeroMadera?.touched || submitted)" class="text-danger">
										<div *ngIf="transporteGroupForm.controls.numeroMadera.errors?.required">Campo Requerido</div>
										<div *ngIf="transporteGroupForm.controls.numeroMadera.errors?.min">Número inválido</div>
									</div>
								</div>
								<!-- Botón para Obtener Información Geográfica -->
								<div class="col-md-2 text-right">
									<button type="button" class="btn btn-sm btn-primary btn-block" (click)="obtenerInformacionGeograficaDesdeDireccion()" [disabled]="isLoading || obtenerInfoDisabled()">
										<span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
										Obtener Información
									</button>
								</div>
							</div>
						</div>
					</div>

					<!-- Tabla para seleccionar predio cuando hay múltiples resultados -->
					<div class="row" *ngIf="showPrediosTable">
						<div class="col-12">
							<h5>Seleccione un Predio</h5>
							<table class="table table-bordered">
								<thead>
									<tr>
										<th>#</th>
										<th>Dirección</th>
										<th>Acciones</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let predio of multiplePredios; let i = index">
										<td>{{ i + 1 }}</td>
										<td>{{ predio.direccion }}</td>
										<td>
											<button class="btn btn-sm btn-success mr-2" (click)="seleccionarPredio(predio)">Seleccionar</button>
											<button class="btn btn-sm btn-info" (click)="abrirMapa(predio, mapModal)">Mapa</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<!-- Campos Adicionales para Búsqueda por Rol Avalúo -->
				<div *ngIf="transporteGroupForm.get('tipoBusqueda').value === 'rolAvaluo' && transporteGroupForm.get('manejoMaderaCheckbox').value">
					<div class="row">
						<div class="col-12 form-group">
							<div class="row">
								<div class="col-md-3 label-control">Comuna</div>
								<div class="col-md-6 label-control">Rol Avalúo</div>
							</div>
							<div class="row">
								<!-- Comuna -->
								<div class="col-md-3">
									<ng-select formControlName="comuna" [items]="comunas" placeholder="Comuna" bindValue="codigoSii" [searchable]="true" bindLabel="nombre"> </ng-select>
									<div *ngIf="transporteGroupForm.controls.comuna?.invalid && (transporteGroupForm.controls.comuna?.touched || submitted)" class="text-danger">
										<div *ngIf="transporteGroupForm.controls.comuna.errors?.required">Campo Requerido</div>
									</div>
								</div>
								<!-- Rol Avalúo -->
								<div class="col-md-6">
									<input type="text" class="form-control" formControlName="rolAvaluo" required placeholder="Rol Avalúo (ejemplo: 12345-6789)" />
									<div *ngIf="transporteGroupForm.controls.rolAvaluo?.invalid && (transporteGroupForm.controls.rolAvaluo?.touched || submitted)" class="text-danger">
										<div *ngIf="transporteGroupForm.controls.rolAvaluo.errors?.required">Campo Requerido</div>
										<div *ngIf="transporteGroupForm.controls.rolAvaluo.errors?.pattern">Formato inválido. Debe contener solo números y un guión, sin espacios.</div>
									</div>
								</div>
								<!-- Botón para Obtener Información Geográfica -->
								<div class="col-md-2 text-right">
									<button type="button" class="btn btn-sm btn-primary btn-block" (click)="obtenerInformacionGeograficaDesdeRol()" [disabled]="isLoading || obtenerInfoDisabled()">
										<span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
										Obtener Información
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Formulario Manual cuando no hay resultados -->
				<div class="row" *ngIf="showManualForm">
					<div class="col-12">
						<h5>No se encontraron coincidencias. Por favor, reintente</h5>
					</div>
				</div>
				<div class="row" *ngIf="informacionGeografica">
					<!-- Rol Origen -->
					<div class="col-md-2 col-sm-4 form-group">
						<label class="label-control">Rol Origen</label>
						<input type="text" class="form-control" formControlName="mnzRolOrigen" readonly />
					</div>

					<!-- Predio Rol Origen -->
					<div class="col-md-2 col-sm-4 form-group">
						<label class="label-control">Predio Rol Origen</label>
						<input type="text" class="form-control" formControlName="prdRolOrigen" readonly />
					</div>

					<!-- Referencia CONAF -->
					<div class="col-md-2 col-sm-4 form-group">
						<label class="label-control">Referencia CONAF</label>
						<input type="text" class="form-control" formControlName="codPlanConaf" (change)="onSubmit()" />
						<div *ngIf="(transporteGroupForm.controls.codPlanConaf?.touched || submitted)" class="text-danger">
							<div *ngIf="transporteGroupForm.controls.codPlanConaf.errors?.required">Campo Requerido</div>
						</div>
					</div>

					<!-- Latitud -->
					<div class="col-md-2 col-sm-6 form-group">
						<label class="label-control">Latitud</label>
						<input type="text" class="form-control" formControlName="latitudOrigenMadera" readonly />
					</div>

					<!-- Longitud -->
					<div class="col-md-2 col-sm-6 form-group">
						<label class="label-control">Longitud</label>
						<input type="text" class="form-control" formControlName="longitudOrigenMadera" readonly />
					</div>

					<!-- Botón "Ver Mapa" -->
					<div class="col-md-2 col-sm-12 form-group">
						<label class="label-control"> </label>
						<button type="button" class="btn btn-secondary btn-sm btn-block" (click)="abrirMapa(informacionGeografica, mapModal)"><i class="fa fa-map-marker"></i> Ver Mapa</button>
					</div>
				</div>
		</ng-container>
	</form>
</div>

<ng-template #mapModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">Ubicación en Mapa</h5>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div *ngIf="latitudMapa && longitudMapa; else noCoords">
			<p class="mb-3"><strong>Dirección:</strong> {{ direccionMapa }}</p>
			<iframe width="100%" height="400" frameborder="0" style="border: 0" [src]="mapaEmbedUrl" allowfullscreen> </iframe>
		</div>
		<ng-template #noCoords>
			<p>No se disponen de coordenadas para mostrar el mapa.</p>
		</ng-template>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modal.close('Close click')">Cerrar</button>
	</div>
</ng-template>
